export default __webpack_public_path__ + "static/media/ChaltenManual10.7a5b247c.jpg";